import { call, put } from 'redux-saga/effects';
import { AppInfoAPI } from '../apis';
import { APP_INFO_ACTION_TYPES } from '../actionTypes';

export function* getInfo(action) {
  try {
    const response = yield call(AppInfoAPI.get, {supplier: action.payload});
    const payload = response || {};

    yield put({
      type: APP_INFO_ACTION_TYPES.GET.SUCCESS,
      payload,
    });
  } catch (error) {
    yield put({
      type: APP_INFO_ACTION_TYPES.GET.ERROR,
      error,
    });
  }
}
